import React from "react";
import { Link } from "react-router-dom";
import OptimizedImage from "./ΟptimizedImage";

const stripHtml = (html) => {
  if (!html) return "";
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || "";
};

/**
 * Εμφάνιση άρθρων της κατηγορίας "news".
 * Παρόμοιο layout με InterviewsSection — 3 στήλες σε desktop.
 */
const NewsSection = ({ news }) => {
  if (!news || news.length === 0)
    return (
      <div className="text-center py-5 text-dark">
        Δεν υπάρχουν νέα προς το παρόν.
      </div>
    );

  return (
    <section className="news-section bg-gray-100 py-5">
      <div className="container">
        <h2 className="text-primary fw-bold border-bottom border-2 border-primary d-inline-block mb-4 px-2">
          NEWS
        </h2>

        <div className="row">
          {news.map((article) => (
            <div key={article.id} className="col-md-4 mb-4">
              <div className="card shadow-sm h-100 border-0 rounded-lg overflow-hidden">
                <Link to={`/articles/${article.id}`}>
                  <OptimizedImage
                    src={article.mainImageUrl || article.image}
                    alt={article.title}
                    className="card-img-top w-100"
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                </Link>

                <div className="card-body d-flex flex-column">
                  <Link
                    to={`/articles/${article.id}`}
                    className="text-decoration-none"
                  >
                    <h5 className="card-title fw-bold text-dark hover-text-primary">
                      {article.title}
                    </h5>
                  </Link>

                  <p className="card-text text-secondary small flex-grow-1">
                    {stripHtml(article.content)?.slice(0, 100)}...
                  </p>

                  <div className="d-flex justify-content-between align-items-center mt-2">
                    <small className="text-muted">
                      {article.createdAt?.toDate().toLocaleDateString("el-GR", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })}
                    </small>
                    <span className="badge bg-dark text-white p-2">
                      {article.genre || article.category}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
